import * as yup from 'yup';
//const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
// const phoneRegExp = /^\+?[1-9]\d{1,14}$/;

const validateProfileForm = yup.object({
  firstName: yup.string().required('First name is a required field'),
  lastName: yup.string().required('Last name is a required field'),
  email: yup.string().email('Email must be a valid email').required('Email is a required field'),
  password: yup.string().required('Password is a required field'),
  newFirstname: yup.string().required('First name is a required field'),
  newLastname: yup.string().required('Last name is a required field')
});

export default validateProfileForm;
